import { render, staticRenderFns } from "./SearchResultPage.vue?vue&type=template&id=6f5bb3f2&scoped=true"
import script from "./SearchResultPage.vue?vue&type=script&lang=js"
export * from "./SearchResultPage.vue?vue&type=script&lang=js"
import style0 from "./SearchResultPage.vue?vue&type=style&index=0&id=6f5bb3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5bb3f2",
  null
  
)

export default component.exports